function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var i = Object.defineProperty;

var d = function d(t, e, n) {
  return e in t ? i(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : t[e] = n;
};

var r = function r(t, e, n) {
  return d(t, _typeof(e) != "symbol" ? e + "" : e, n), n;
};

var o = /*#__PURE__*/function () {
  function o() {
    _classCallCheck(this, o);

    r(this, "current", this.detect());
    r(this, "handoffState", "pending");
    r(this, "currentId", 0);
  }

  _createClass(o, [{
    key: "set",
    value: function set(e) {
      this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.set(this.detect());
    }
  }, {
    key: "nextId",
    value: function nextId() {
      return ++this.currentId;
    }
  }, {
    key: "isServer",
    get: function get() {
      return this.current === "server";
    }
  }, {
    key: "isClient",
    get: function get() {
      return this.current === "client";
    }
  }, {
    key: "detect",
    value: function detect() {
      return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
  }, {
    key: "handoff",
    value: function handoff() {
      this.handoffState === "pending" && (this.handoffState = "complete");
    }
  }, {
    key: "isHandoffComplete",
    get: function get() {
      return this.handoffState === "complete";
    }
  }]);

  return o;
}();

var s = new o();
export { s as env };